import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import merge from 'deepmerge';
import apiConfig from './apiConfig';
import { AuthProtect } from '@/common/enum';
import type EndPointTypes from 'interfaces/EndPointTypes';
import { store } from '@/store';

export const genericErrorMessage =
  'We just experienced a technical issue, please wait a few seconds and try again.';

const DashboardBaseURL = import.meta.env.VITE_DASHBOARD_API_ENDPOINT;

async function apiFetch<T>(
  api: EndPointTypes,
  controller?: AbortController
): Promise<{ status: number; data: T }> {
  const params: any = api.params || {};
  const { headers } = apiConfig;
  const baseURL = api?.defaultBaseURL || DashboardBaseURL;
  if (api.authorization === AuthProtect.REQUIRED) {
    const jwt = store.getState().auth.token;
    if (jwt) {
      params.access_token = jwt;
    }
  }
  const apiConfigMerge: AxiosRequestConfig = merge.all([
    apiConfig,
    api,
    {
      baseURL,
      headers,
      params,
      paramsSerializer: (
        params: Record<string, string | number | boolean | (string | number | boolean)[]>
      ) => {
        const searchParams = new URLSearchParams();
        for (const key in params) {
          const value = params[key];
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v.toString()));
          } else if (value !== undefined && value !== null) {
            searchParams.append(key, value.toString());
          }
        }
        return searchParams.toString();
      },
    },
  ]);
  const axiosCreate = axios.create(apiConfigMerge);
  axiosCreate.interceptors.request.use(
    async function (config) {
      if (controller) {
        config.signal = controller.signal;
      }
      if (api.authorization === AuthProtect.REQUIRED) {
        const jwt = store.getState().auth.token;
        if (jwt) {
          config.headers.Authorization = jwt;
        }
      }
      return config;
    },
    function (error) {
      console.log('🚀apiFetch function ERROR: ', error);
      throw Error(error);
    }
  );
  return axiosCreate(api).then(
    (res: AxiosResponse<T>) => {
      return { status: res.status, data: res.data };
    },
    (error) => {
      console.log('🚀apiFetch ERROR: ', error);
      if (error.response) {
        throw Error(JSON.stringify(error.response.data));
        // return { status: error.response.status, data: error.response.data };
      } else {
        throw Error(genericErrorMessage);
        // return { status: 500, data: genericErrorMessage };
      }
    }
  );
}

export default apiFetch;
